import {
  ragResultToolOperator,
  type RagResultToolOperator,
} from '@form-factory/schema/contracts';
import type { ThreadMode } from '@form-factory/schema/enums';
import type { PartialDeep } from 'type-fest';

import type { ToolComponentProps } from './ToolProvider';
import { createToolComponent } from '../../toolRegistry';
import { Markdown } from '../Markdown';
import { OperatorInfo } from '../operator/OperatorInfo';
import { Message } from '../ui/Message';

export interface OperatorResultToolProps
  extends ToolComponentProps<PartialDeep<RagResultToolOperator>> {
  mode?: ThreadMode;
}

const hasDisplayText = (text?: string | null): text is string => {
  if (!text) return false;
  const normalizedText = text.trim().toLowerCase();

  return (
    !!normalizedText &&
    normalizedText.length > 0 &&
    normalizedText !== 'null' &&
    normalizedText !== 'undefined'
  );
};

export const OperatorResultTool = createToolComponent<
  OperatorResultToolProps,
  typeof ragResultToolOperator
>(
  {
    schema: {
      args: ragResultToolOperator,
    },
  },
  ({ toolCall, mode }) => {
    const { operator, content } = toolCall.args;

    return (
      <Message.BubbleGroup>
        <Message.Bubble>
          <Markdown>{content ?? ''}</Markdown>
        </Message.Bubble>
        <OperatorInfo operator={operator} />
        {hasDisplayText(operator?.displayText) && (
          <Message.Bubble>
            <Markdown>{operator.displayText}</Markdown>
          </Message.Bubble>
        )}
      </Message.BubbleGroup>
    );
  },
);
